"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteJiraCredentialsSlice = void 0;
const xuder_1 = require("@sonar-software/xuder");
const _api_1 = require("../../api/index.js");
const get_1 = require("./summary/get.js");
exports.deleteJiraCredentialsSlice = (0, xuder_1.createDeleteAsyncSlice)({
    httpSagaOptions: {
        successActionCreators: [get_1.getJiraSummarySlice.asyncActionCreators.requestGetJiraSummary]
    },
    name: 'jiraCredentials',
    receive: false,
    request: true,
    requestHandler: _api_1.deleteJiraCredentials
});
//# sourceMappingURL=delete.js.map